import gql from 'graphql-tag';

export const CREATE_ACCOMMODATION_BOOKING = gql`
  mutation createAccommodationBooking(
    $accommodationBooking: AccommodationBookingInput!
    $activitiesBookings: [ActivityBookingInput]
  ) {
    createAccommodationBooking(
      accommodationBooking: $accommodationBooking
      activitiesBookings: $activitiesBookings
    ) {
      id
      clientSecret
      nextActionUrl
    }
  }
`;

export const UPDATE_ACCOMMODATION_BOOKING = gql`
  mutation updateAccommodationBooking(
    $accommodationBooking: AccommodationBookingInput!
    $activitiesBookings: [ActivityBookingInput]
    $deletedActivityBookings: [Int]
  ) {
    updateAccommodationBooking(
      accommodationBooking: $accommodationBooking
      activitiesBookings: $activitiesBookings
      deletedActivityBookings: $deletedActivityBookings
    ) {
      id
    }
  }
`;

export const UPDATE_ACTIVITY_BOOKING = gql`
  mutation updateActivityBooking($activityBooking: ActivityBookingInput!) {
    updateActivityBooking(activityBooking: $activityBooking) {
      id
    }
  }
`;
